import mixpanel from "mixpanel-browser";
import { isDev } from "../helper";

mixpanel.init("04522e1541f6100b1b5056d7c4bc839f", {
  ip: true,
  //   debug: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
});

// let env_check = process.env.NODE_ENV === "production";
let env_check = true;

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;
